import React from "react";
import useSPPosition from "../../hooks/useSPPosition";
import useSPUndo from "../../hooks/useSPUndo";
import useGlobalParams from "../../hooks/useGlobalParams";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import Incoterms from "../Misc/Incoterms";
import SearchField from "../SearchField/SearchField";
import SPPositionFormGroup from "./SPPositionFormGroup";

const PositionsSPDelivery = ({ showinfo, setShowinfo, clearfield }) => {
  // Load context values
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, undoListSP } = useSPUndo();
  const { globalparams } = useGlobalParams();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      positionEditsSP,
      editIDSP,
      setEditIDSP,
      setSPposition,
      setSPpositionData,
      addEdits,
      undoListSP,
      origin,
      destination,
      globalparams
    );
  };
  return (
    <fieldset style={{ overflow: "visible" }}>
      <legend>Delivery:</legend>
      <div className='form-group' style={{ overflow: "visible" }}>
        <label
          className='pincoterm-container'
          onMouseEnter={(e) => {
            setShowinfo("pincoterm");
          }}
          onMouseLeave={(e) => {
            setShowinfo("");
          }}
        >
          P Inco: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
          {showinfo === "pincoterm" && (
            <div
              className='pincoterminfo'
              onMouseEnter={(e) => {
                setShowinfo("pincoterm");
              }}
              onMouseLeave={(e) => {
                setShowinfo("");
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                <p> Info</p>
              </div>
              <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                Enter the Purchase Incoterm.
              </p>
              <Incoterms />
            </div>
          )}
        </label>
        <SearchField
          required={true}
          searchURL='/api/positions/getpincoterms'
          value={SPposition?.pincoterm || ""}
          valueName='pincoterm'
          valueID='pincotermID'
          customplaceholder='P Incoterm'
          onItemSelect={(item) => localHandleInputSelect(item, "pincoterm", "pincoterm")}
          clearfield={clearfield}
        />
      </div>
      <div className='form-group' style={{ overflow: "visible" }}>
        <label
          className='pincoterm-container'
          onMouseEnter={(e) => {
            setShowinfo("sincoterm");
          }}
          onMouseLeave={(e) => {
            setShowinfo("");
          }}
        >
          D Inco: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
          {showinfo === "sincoterm" && (
            <div className='pincoterminfo'>
              <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                <p> Info</p>
              </div>
              <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                Enter the Delivery Incoterm.
              </p>
              <Incoterms />
            </div>
          )}
        </label>
        <SearchField
          required={true}
          searchURL='/api/positions/getsincoterms'
          value={SPposition?.sincoterm || ""}
          valueName='sincoterm'
          valueID='sincotermID'
          customplaceholder='D Incoterm'
          onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
          clearfield={clearfield}
        />
      </div>
      <SPPositionFormGroup type={"date"} labelname={"From"} inputname={"shipfrom"} inputtype={"text"} />
      <SPPositionFormGroup type={"date"} labelname={"To"} inputname={"shipuntil"} inputtype={"text"} />
      <div className='form-group'>
        <label>POL:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getlports'
          value={SPposition?.POL || ""}
          valueName='POL'
          valueID='POLID'
          customplaceholder='POL'
          onItemSelect={(item) => localHandleInputSelect(item, "POL", "POL")}
          clearfield={clearfield}
        />
      </div>
      <div className='form-group'>
        <label>POD:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getdports'
          value={SPposition?.POD || ""}
          valueName='POD'
          valueID='PODID'
          customplaceholder='POD'
          onItemSelect={(item) => localHandleInputSelect(item, "POD", "POD")}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default PositionsSPDelivery;
